// Base (main requirements, polyfills, etc.)
import './bootstrap'

// Import Modules
import axios from 'axios'
import pluralize from 'pluralize'

// Vue Imports
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'

// Vee Validate Imports
import { extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

// Config files
import auth from './config/auth'
import router from './config/router'

// Global Components
import App from './App.vue'
import Verify from './Verify.vue';
import FeedbackContainer from './components/FeedbackContainer.vue'
import {FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";

// Set Vue globally
window.Vue = Vue;

// Set up Vue event bag
window.events = new Vue();

// allow the UserFeedback component to be used
window.feedback = function (message, level = 'success') {
    window.events.$emit('feedback', { message, level });
};

// Set Vue router
Vue.router = router;
Vue.use(VueRouter);

// Set Vue with Axios
Vue.use(VueAxios, axios);
axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`;

// Set Vue Authentication
Vue.use(VueAuth, auth);

// Intercept the axios response and check if it is a 401
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    // console.log(error.response);
    if (error.response.status === 401) {
        if (error.response.data.message === 'The token expired.') {
            feedback('Your session has expired, please log in again', 'danger');
        } else if (error.response.data.message === 'User is disabled') {
            feedback('Your account has been disabled. Please contact support.', 'danger');
        } else {
            feedback(error.response.data.message, 'danger');
        }
    }

    return Promise.reject(error);
});

// Load Components
Vue.component('app', App);
Vue.component('feedback', FeedbackContainer);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

Vue.component('verify', Verify)

Vue.mixin({
    methods: {
        delay: function (callback, ms) {
            let timer = 0;
            return function () {
                let context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            }
        },

        delegate: (selector) => (callback) => (el) => el.target.matches(selector) && callback(el),

        capitalize: function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        plural: function(word, count = 1, inclusive = false) {
            return pluralize(word, count, inclusive)
        },

        loggedIn: function () {
            return this.$auth.check();
        },

        app_env: function() {
            return process.env.MIX_APP_ENV && typeof process.env.MIX_APP_ENV != 'undefined' ? process.env.MIX_APP_ENV : false;
        },
    },

    computed: {
        isEmployee: function () {
            if(this.loggedIn()) {
                return this.$auth.user().roles.includes("Leonards Employee") || this.$auth.user().roles.includes("System Admin");
            }

            return false;
        },
    }
});

// Vee Validate Setup
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

localize('en', en);

new Vue({
    router,
    render: h => h(App)
}).$mount('#vue-app');
